import { useState } from "react";
import { PrimaryButton } from "../../../../components/Buttons";
import { colors } from "../../../../components/colors";
import { EditImageModal } from "./EditImageModal";

type Props = {
  uploadImage: (request: any) => Promise<string>;
  imageUploadIsLoading: boolean;
  modalHeader: string;
};

export const EditImageSelector = ({
  uploadImage,
  imageUploadIsLoading,
  modalHeader,
}: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div>
      <PrimaryButton
        color={colors.white}
        backgroundColor={colors.ctaMain}
        hoverColor={colors.ctaSecondaryOne}
        onClick={() => setModalOpen(true)}
        type="button"
      >
        Edit image
      </PrimaryButton>
      <EditImageModal
        modalHeader={modalHeader}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        uploadImage={uploadImage}
        imageUploadIsLoading={imageUploadIsLoading}
      />
    </div>
  );
};
